import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/assets/style/main.scss'

const isDev = process.env.NODE_ENV === 'development'
const prodApi = process.env.VUE_APP_PROD_API
const localApi = process.env.VUE_APP_LOCAL_API
// When local API is empty, use /api proxy (avoids conflict with Vue route /pages)
export const baseURL = isDev && !localApi ? '/api' : (isDev ? localApi : prodApi)
export const assetBase = isDev && !localApi ? prodApi : baseURL

axios.defaults.baseURL = baseURL

const AUTH_TOKEN_KEY = 'token'
axios.interceptors.request.use(config => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY)
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(AUTH_TOKEN_KEY)
      if (window.__adminVueRoot && typeof window.__adminVueRoot.$emit === 'function') {
        window.__adminVueRoot.$emit('logout')
      }
    }
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

Vue.use({
  install (Vue) {
    Vue.prototype.$path = assetBase
  }
})

const app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
if (app.$root) {
  window.__adminVueRoot = app.$root
}
